import { CallsPayload } from '@src/api/payload.class';
import { providerKeyData } from '@src/utility/common.service';
import {
  dateFormatterWithLeadingZero,
  formatValue,
  nFormatter,
} from '@src/utility/commonUtilityServices';
import {
  checkIsInternal,
  getMultiTins,
  isMultiTinVal,
} from '@src/utility/createStorage';
import httpService from '@src/utility/httpService';
import { config } from '@uhg-abyss/web/tools/config';

import { roundingPercentage } from '@src/apps/DigitalSummary/Main/constant';
import {
  getCallsMonthDetailsMock,
  getCallsSummaryMock,
  getCallTypeDataMock,
  getQuickFiltersData,
} from './sampleAPI';
import { checkSingleTin, checkMultiTin, checkHCO } from '@src/utility/createStorage';

const _httpService = new httpService();
if (checkIsInternal()) {
  _httpService.setBaseURL(config('API_DOMAIN_INTERNAL'));
} else {
  _httpService.setBaseURL(config('API_DOMAIN_EXTERNAL'));
}
interface TinData {
  Tin: string;
  TinName: string;
  [key: string]: any; // For any other properties that might exist
}

interface ApiResponse {
  Data?: TinData[];
  StatusCode?: number;
  Status?: string;
  Message?: string;
  [key: string]: any; // For any other properties that might exist
}
export const CALLS_TREND_MOCK_DATA = {
  titleID: 263,
  MetricID: null,
  data: {},

  timeperiod: '',
  title: 'Call Volume by Month',
  approach: 'default',
  status: 404,

  legendObj: {
    chartId: 'legends',
    compareLobs: true,
    filterType: 'LOB',
    legendData: [],
  },
  drawerContent: {
    title: 'Compare Lines of Business',
    IndividualText: 'Individual Lines of Business',
    mainCheckbox: {
      displayValue: 'All Lines of Business',
      value: '',
    },
    checkboxList: [
      {
        checked: true,
        value: 'Commercial',
        code: 'EI',
      },
      {
        checked: true,
        value: 'Medicare',
        code: 'MR',
      },
      {
        checked: true,
        value: 'Medicaid',
        code: 'CS',
      },
    ],
    disableClose: true,
    mode: 'over',
    position: 'end',
  },
  graphMultiLineObj: {
    chartId: 'appeals-graph',
    chartType: 'dynamicMultiline-graph',
    value: 0,
    generalData: [],
    generalData2: [{}],
    graphValues: [],
    titleData: [{}],
    chartData: [],
  },
};
const lobObj = {
  CS: 'MEDICAID',
  EI: 'COMMERCIAL',
  MR: 'MEDICARE',
  UN: 'UNCATEGORIZED',
  DL: 'DUAL',
};

const months = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
];

const getParameters = (param) => {
  let parameters = [];
  const providerKey = providerKeyData();
  parameters = [providerKey, new CallsPayload(param)];
  return parameters;
};

function getSummaryparams(params) {
  let tinStr = '';
  if (!params[1]?.Tin) {
    params[1].Tin = [
      {
        Tin: 'All',
        Tinname: 'All',
      },
    ];
  }
  params[1].Tin.forEach((element) => {
    tinStr = tinStr + ',' + element.Tin;
  });
  const param = {
    ProviderSysKey: params[0],
    TimeFilter: params[1].TimeFilter,
    TimeFilterText: params[1].TimeFilterText,
    Lob: params[1].Lob === 'All' ? undefined : params[1].Lob,
    Tins: params[1].Tin[0].Tin === 'All' ? undefined : tinStr.slice(1),
  };
  return param;
}

function setMultiTinsOrProviderSysKey(params) {
  if (isMultiTinVal()) {
    params.Tins = getMultiTins();
    delete params['ProviderSysKey'];
  }
  const sessionState = JSON.parse(sessionStorage.getItem('state'));
  let tinText = '';
  if (sessionState?.taxId && sessionState?.taxId[0].Tin !== 'All') {
    sessionState.taxId.forEach((element) => {
      tinText += element.Tin + ',';
    });
    params.Tins = tinText.replace(/,$/, '');
  }
  return params;
}

function getCardDetails(response) {
  const cards_Array = [
    {
      status: response.Data === null ? '404' : null,
      title: 'Total Call Volume',
      width: '',
      cardValues: {
        total: {
          value: response.Data.TotalCallVolume,
          autoUnits: true,
        },
      },
    },
    {
      status: !response ? '404' : null,
      title: 'Total Talk Time (hrs)',
      width: '',
      cardValues: {
        total: {
          value: response.Data.TotalCallTime / 60,
          autoUnits: true,
        },
      },
    },
    {
      status: !response ? '404' : null,
      title: 'Avg. Time per call (mins)',
      width: '',
      cardValues: {
        total: {
          value: Number(roundingPercentage(response.Data.AverageTime)),
          autoUnits: true,
        },
      },
    },
    {
      status: !response ? '404' : null,
      title: 'Transfer Rate',
      width: '',
      cardValues: {
        total: {
          value: response.Data.TransferRate * 100,
          autoUnits: true,
          postfix: true,
          units: '%',
        },
      },
    },
  ];
  return cards_Array;
}

function getDetailsSetResult(parameters: any): any {
  const params = getParameters(parameters);
  let tinStr = '';
  params[1].Tin.forEach((element) => {
    tinStr = tinStr + ',' + element.Tin;
  });
  const payloadVolume = {
    ProviderSysKey: params[0],
    TimeFilter: params[1].TimeFilter,
    TimeFilterText: params[1].TimeFilterText,
    CallType: 'volume',
    Lob: params[1].Lob === 'All' ? undefined : params[1].Lob,
    Tins: params[1].Tin[0].Tin === 'All' ? undefined : tinStr.slice(1),
  };
  const payloadTime = {
    ProviderSysKey: params[0],
    TimeFilter: params[1].TimeFilter,
    TimeFilterText: params[1].TimeFilterText,
    CallType: 'talktime',
    Lob: params[1].Lob === 'All' ? undefined : params[1].Lob,
    Tins: params[1].Tin[0].Tin === 'All' ? undefined : tinStr.slice(1),
  };
  return { params, tinStr, payloadVolume, payloadTime };
}

function getCallVolumeDetails(callVolume, response) {
  if (!callVolume || callVolume.length === 0) {
    return {
      title: 'Top Call Types by Volume',
      status: 404,

      toggle: true,
      data: null,
      besideData: null,
      timeperiod: null,
    };
  }

  callVolume.sort((a, b) => b.CallVolume - a.CallVolume);
  const barScaleMax = callVolume[0].CallVolume;
  const timePeriodValue = `${dateFormatterWithLeadingZero(
    response.Data.PeriodStart
  )}-${dateFormatterWithLeadingZero(response.Data.PeriodEnd)}`;

  const data = callVolume.map((volume, i) => {
    const percentage = (volume.CallVolume / barScaleMax) * 100;
    return {
      data: volume.CallVolume,
      summation: barScaleMax,
      percentage: percentage,
      text: volume.CallTypeDef,
      formatValue: formatValue(Number(volume.CallVolume)),
      color: '#3381FF',
    };
  });
  return {
    title: 'Top Call Types by Volume',
    data: data,
    timeperiod: timePeriodValue,
    status: 200,
  };
}
function getCallTalkTimeDetails(callTime, response) {
  if (!callTime || callTime.length === 0) {
    return {
      status: 404,
      title: 'Top Call Types by Talk Time',

      data: null,
      timeperiod: null,
    };
  }

  callTime.sort((a, b) => b.TotalCallTimeInMinutes - a.TotalCallTimeInMinutes);
  const barScaleMax = callTime[0].TotalCallTimeInMinutes / 60;
  const timePeriodValue = `${dateFormatterWithLeadingZero(
    response.Data.PeriodStart
  )}-${dateFormatterWithLeadingZero(response.Data.PeriodEnd)}`;

  const data = callTime.map((time, i) => {
    const timeInMinutes = time.TotalCallTimeInMinutes;
    const timeType = timeInMinutes <= 60 ? ' mins' : ' hrs';
    const timeValue = timeInMinutes <= 60 ? timeInMinutes : timeInMinutes / 60;
    const timeValue2 =
      timeInMinutes <= 60 ? timeInMinutes / 60 : Math.round(timeInMinutes / 60);
    const percentage = (timeInMinutes / 60 / barScaleMax) * 100;
    return {
      type: timeType,
      percentage: percentage,
      data: timeValue2,
      value: timeValue,
      formatValue: `${formatValue(Number(timeValue2))}${timeType}`,
      summation: barScaleMax,
      text: time.CallTypeDef,
      color: '#3381FF',
    };
  });
  return {
    title: 'Top Call Types by Talk Time',

    data: data,
    timeperiod: timePeriodValue,
    status: 200,
  };
}

function getTrendCardDetails(response) {
  const layout_values = [
    { key: 'Volume', code: 'Volume' },
    { key: 'TalkTime', code: 'TalkTime' },
  ];
  const {
    SumOfcallVolume: volumeTotal,
    SumOftotalCallTimeInMinutes: timeTotal,
  } = response?.Data || [];

  return layout_values.map((item) => {
    const card_data = {
      status: 200,
      title: '',
      type: response?.Data?.type,
      value: null,
      code: item.code,
      color: '',
    };

    card_data.title = item.key;
    card_data['autoUnits'] = true;
    if (item.key === 'Volume') {
      card_data.value = volumeTotal;
      card_data.status = !volumeTotal ? 404 : 200;
    }
    if (item.key === 'TalkTime' && timeTotal !== '0') {
      card_data.value = timeTotal;
      card_data.status = !timeTotal ? 404 : 200;
    }
    if (timeTotal === '0' && item.key === 'TalkTime') {
      card_data.value = null;
      card_data.status = 404;
    }
    return card_data;
  });
}
function getColorforgeneral(value: any) {
  let ColorVal = '';
  if (value === 'All') {
    ColorVal = '#2D2D39';
  }
  if (value === 'Commercial') {
    ColorVal = '#013DA1';
  }
  if (value === 'Medicare') {
    ColorVal = '#3481FF';
  }
  if (value === 'Medicaid') {
    ColorVal = '#80B0FF';
  }
  return ColorVal;
}
function getTrendGeneralData(color: any, lob: any) {
  return {
    backgroundColor: null,
    barColor: color,
    trendIndicator: lob === 'All' ? 'dotted-bar3' : 'solid-bar3',
    label: lob,
    barGraphNumberSize: 18,
    hideYAxis: false,
    tooltipBoolean: true,
    width: 961,
    height: 270,
    yAxisUnits: '',
  };
}
function getColorandSortData(selection: any) {
  let backColor = '';
  let sortOrder = 0;
  if (selection?.value === 'All') {
    backColor = '#2D2D39';
    sortOrder = 0;
  }
  if (selection?.value === 'Commercial') {
    backColor = '#013DA1';
    sortOrder = 1;
  }
  if (selection?.value === 'Medicare') {
    backColor = '#3481FF';
    sortOrder = 2;
  }
  if (selection?.value === 'Medicaid') {
    backColor = '#80B0FF';
    sortOrder = 3;
  }
  return { sortOrder: sortOrder, backColor: backColor };
}
function getLegendVal(
  legends,
  selectedObj,
  selName,
  sortOrder,
  backColor,
  radioVal
) {
  let legendName;
  if (selectedObj?.type === 'All' && radioVal === 'Volume') {
    legendName = 'Total Call Volume';
  }
  if (selectedObj?.type === 'All' && radioVal === 'TalkTime') {
    legendName = 'Total Talk Time (hrs)';
  }
  return {
    borderRight: legends.length > 1 && selectedObj?.type === 'All',
    name: selectedObj?.type === 'All' ? legendName : selName?.value,
    trendIndicator: selectedObj?.type === 'All' ? 'dotted-bar3' : 'solid-bar3',
    value: selectedObj?.value,
    backgroundcolor: backColor,
    trend: { text: '' },
    sortOrder: sortOrder,
    status: selectedObj?.value ? null : 404,
  };
}
function getIndValue(month: any) {
  const obj = {
    Jan: 0,
    Feb: 1,
    Mar: 2,
    Apr: 3,
    May: 4,
    Jun: 5,
    Jul: 6,
    Aug: 7,
    Sep: 8,
    Oct: 9,
    Nov: 10,
    Dec: 11,
  };
  return obj[month];
}
function getDatamanipulation(
  response: any,
  checklist: any,
  radioVal: any,
  legends: any,
  respObj: any
) {
  CALLS_TREND_MOCK_DATA.graphMultiLineObj.generalData = [];
  for (let i = 0; i < checklist.length; i++) {
    if (checklist[i].checked) {
      const color = getColorforgeneral(checklist[i].value);
      const obj = getTrendGeneralData(color, checklist[i].value);
      CALLS_TREND_MOCK_DATA.graphMultiLineObj.generalData.push(obj);
    }
  }
  CALLS_TREND_MOCK_DATA.legendObj.legendData = legends.map((v) => {
    const selectedObj = v.find((val) => val.code === radioVal);
    const selName = checklist.find((item) => item.code === selectedObj?.type);
    const { sortOrder, backColor } = getColorandSortData(selName);
    return getLegendVal(
      legends,
      selectedObj,
      selName,
      sortOrder,
      backColor,
      radioVal
    );
  });
  CALLS_TREND_MOCK_DATA.timeperiod =
    dateFormatterWithLeadingZero(response[0]?.Data?.PeriodStart) +
    '-' +
    dateFormatterWithLeadingZero(response[0]?.Data?.PeriodEnd);
  CALLS_TREND_MOCK_DATA.graphMultiLineObj.chartData = [];
  let year = '';
  let yearChanged = false;
  for (let i = 0; i < respObj.length; i++) {
    CALLS_TREND_MOCK_DATA.graphMultiLineObj.chartData[i] = [];
    for (let j = 0; j < respObj[i].length; j++) {
      yearChanged = year !== respObj[i][j].date;
      if (yearChanged) {
        CALLS_TREND_MOCK_DATA.graphMultiLineObj.chartData[i][j] = {
          name: respObj[i][j].name,
          value: respObj[i][j].value,
          ind: getIndValue(respObj[i][j].name.split(' ')[0]),
          year: respObj[i][j].date,
        };
      } else {
        CALLS_TREND_MOCK_DATA.graphMultiLineObj.chartData[i][j] = {
          name: respObj[i][j].name,
          value: respObj[i][j].value,
          ind: getIndValue(respObj[i][j].name.split(' ')[0]),
        };
      }
      year = respObj[i][j].date;
    }
  }
  CALLS_TREND_MOCK_DATA.MetricID = '313';
  return CALLS_TREND_MOCK_DATA;
}
function modifyResponseForTrend(response: any, type: any) {
  const respObj = new Array();
  for (let i = 0; i < response?.length; i++) {
    respObj[i] = [];
    if (response[0]?.Data?.MonthSummary?.length > 0) {
      for (let j = 0; j < response[i].Data.MonthSummary.length; j++) {
        respObj[i].push({
          name: months[
            parseInt(
              response[i]?.Data?.MonthSummary[j]?.CallDate.split('-')[1]
            ) - 1
          ],
          value:
            type === 'Volume'
              ? response[i]?.Data?.MonthSummary[j]?.CallVolume
              : parseFloat(
                (
                  response[i]?.Data?.MonthSummary[j]?.TotalCallTimeInMinutes /
                  60
                ).toString()
              ).toFixed(1),
          date: response[i]?.Data?.MonthSummary[j]?.CallDate.split('-')[0],
          actualDate: new Date(response[i]?.Data?.MonthSummary[j]?.CallDate),
        });
      }
    }
  }
  return respObj;
}
function fixResponseForTrends(response, radio) {
  if (radio === 'Volume') {
    CALLS_TREND_MOCK_DATA.title = 'Call Volume by Month';
  } else {
    CALLS_TREND_MOCK_DATA.title = 'Talk Time by Month';
  }
  let maxLengthIndex = -1;
  let index = -1;
  for (let i = 0; i < response.length; i++) {
    if (response[i].length > maxLengthIndex) {
      maxLengthIndex = response[i].length;
      index = i;
    }
  }
  for (let i = 0; i < response.length; i++) {
    if (response[i].length < response[index].length) {
      for (let j = 0; j < response[index].length; j++) {
        if (
          response[i][j]?.actualDate?.getTime() !==
          response[index][j]?.actualDate?.getTime()
        ) {
          const obj = {
            name: response[index][j].name,
            value: 0,
            date: response[index][j].date,
          };
          response[i].splice(j, 0, obj);
        }
      }
    }
  }
  return response;
}

export const configSessionValues = (testSimulation = false) => {
  const data = async () => {
    console.log('Call page service called!');
  };
  return data();
};




export const getQuickFiltersTinList = async () => {
  try {
    const contractIdFlow = sessionStorage.getItem('contractIdNavigation') === 'true';

    const providerInfo = JSON.parse(
      sessionStorage.getItem('providerInfo') ?? '{"ProviderSysKey": ""}'
    );
    const providerSysKey = providerInfo.ProviderSysKey ?? '';

    let timeFilter = "DatesSplit";
    let timeFilterText = "2025/01/01-2025/04/30";

    try {
      const piTimePeriod = sessionStorage.getItem('piTimePeriod');
      if (piTimePeriod) {
        const parsedTimePeriod = JSON.parse(piTimePeriod);
        if (parsedTimePeriod && parsedTimePeriod.value) {
          const timeParts = parsedTimePeriod.value.split('-');
          if (timeParts.length > 1) {
            timeFilterText = parsedTimePeriod.value;
            timeFilter = "DatesSplit";
          } else {
            timeFilterText = parsedTimePeriod.value;
            timeFilter = "CalendarYear";
          }
        }
      }
    } catch (err) {
      console.error("Error parsing time filter from session storage:", err);
    }


    let tinResponse = null;
    let hcoResponse = null;
    const selectedTins = sessionStorage.getItem('multiSelectedTins');

    if (checkMultiTin() && !contractIdFlow) {
      try {
        tinResponse = await _httpService.push('/extended-tins/top-filter?items=MULTITIN', {
          RequestedJourney: 'provTinListFilter',
          ProvTinListFilter: {
            Tin: selectedTins
          }
        });
      } catch (tinError) {
        console.error("Multi-TIN API call failed:", tinError);
      }

      try {
        hcoResponse = await _httpService.push('/standard-search/topfilter', {
          RequestedJourney: 'paymentIntegrityFilter',
          PaymentIntegrityFilter: {
            ProviderSysKey: providerSysKey,
            TimeFilter: timeFilter,
            TimeFilterText: timeFilterText,
            Tin: selectedTins
          }
        });
      } catch (hcoError) {
        console.error("HCO API call with paymentIntegrityFilter journey failed:", hcoError);
      }
    } else if (checkSingleTin() && !contractIdFlow) {
      try {
        tinResponse = await _httpService.push('/extended-tins/top-filter?items=TIN', {
          RequestedJourney: 'provTinListFilter',
          ProvTinListFilter: {
            Tin: selectedTins
          }
        });
      } catch (tinError) {
        console.error("Single-TIN API call failed:", tinError);
      }

      try {
        hcoResponse = await _httpService.push('/standard-search/topfilter', {
          RequestedJourney: 'paymentIntegrityFilter',
          PaymentIntegrityFilter: {
            ProviderSysKey: providerSysKey,
            TimeFilter: timeFilter,
            TimeFilterText: timeFilterText,
            Tin: selectedTins
          }
        });
      } catch (hcoError) {
        console.error("HCO API call with paymentIntegrityFilter journey failed:", hcoError);
      }
    } else {
      try {
        hcoResponse = await _httpService.push('/standard-search/topfilter', {
          RequestedJourney: 'provTinListFilter',
          ProvTinListFilter: { ProviderSysKey: providerSysKey }
        });
      } catch (hcoError) {
        console.error("HCO API call failed:", hcoError);
      }
    }

    if (tinResponse && tinResponse.Data && hcoResponse && hcoResponse.Data) {
      const uniqueTins = {};
      tinResponse.Data.forEach(tin => {
        uniqueTins[tin.Tin] = tin;
      });

      hcoResponse.Data.forEach(tin => {
        if (!uniqueTins[tin.Tin]) {
          uniqueTins[tin.Tin] = tin;
        }
      });

      tinResponse.Data = Object.values(uniqueTins);
      return tinResponse;
    } else if (tinResponse && tinResponse.Data) {
      return tinResponse;
    } else if (hcoResponse && hcoResponse.Data) {
      return hcoResponse;
    }

    return null;
  } catch (error) {
    console.error('Quick filter API call failed:', error);
    return null;
  }
};

export const getCallsSummaryData = async (parameters, isDefault = false) => {
  const summaryError = {
    MetricID: 311,
    category: 'app-card',
    cards: null,
    hideFooter: false,
    timeperiod: '',
    title: 'Calls Summary',
    titleId: null,
    titleID: 261,
    status: 404,
    type: '',
  };

  const params = getParameters(parameters);
  let param = isDefault ? parameters : getSummaryparams(params);
  param = setMultiTinsOrProviderSysKey(param);

  try {
    const response = await _httpService.push('/calls/summary', param);

    if (response?.Data) {
      const periodStart = dateFormatterWithLeadingZero(
        response.Data.PeriodStart
      );
      const periodEnd = dateFormatterWithLeadingZero(response.Data.PeriodEnd);
      const timePeriodVal = `${periodStart}-${periodEnd}`;

      return {
        MetricID: '311',
        category: 'app-card',
        cards: getCardDetails(response),
        timeperiod: timePeriodVal,
        title: 'Calls Summary',
        titleID: 261,
        type: '',
        status: 200,
      };
    }
  } catch (error) {
    console.error(error);
  }

  return summaryError;
};

export const getCalltypedetailsData = async (parameters, type) => {
  const { payloadVolume, payloadTime } = getDetailsSetResult(parameters);
  const payload = type === 'Volume' ? payloadVolume : payloadTime;
  const updatedPayload = setMultiTinsOrProviderSysKey(payload);

  const callAPI = async (payload) => {
    const endPoint = 'calls/callType';
    try {
      return await _httpService.push(`/${endPoint}`, payload);
    } catch (error) {
      console.error(error);
    }
  };

  try {
    const response = await callAPI(updatedPayload);
    const callData = response?.Data?.CallsByTypes;
    return type === 'Volume'
      ? getCallVolumeDetails(callData, response)
      : getCallTalkTimeDetails(callData, response);
  } catch (error) {
    console.error(error);
  }
};

export async function getCallTrendData(params, checkedList, radio) {
  const parameters = getParameters(params);
  let tinStr = '';

  checkedList.unshift({ checked: true, value: 'All', code: 'All' });
  const checkedListCopy = checkedList.map((v) => {
    v.parameters = { ...parameters[1], Lob: v.code };
    return v;
  });

  if (isMultiTinVal()) {
    tinStr = getMultiTins();
  }

  const sessionState = JSON.parse(sessionStorage.getItem('state'));
  if (sessionState?.taxId && sessionState?.taxId[0].Tin !== 'All') {
    tinStr = sessionState.taxId.map((element) => element.Tin).join(',');
  }

  const callApi = async (payload, index) => {
    const endPoint = 'calls/callByMonth';
    try {
      return await _httpService.push(`/${endPoint}`, payload);
    } catch (error) {
      console.error(error);
    }
  };

  const callsTree = checkedListCopy
    .filter((checkVal) => checkVal.checked)
    .map((checkVal, index) => {
      const payload = {
        ProviderSysKey: isMultiTinVal() ? '' : parameters[0],
        TimeFilter: parameters[1].TimeFilter,
        TimeFilterText: parameters[1].TimeFilterText,
        CallType: radio.toLowerCase(),
        Lob: checkVal.code === 'All' ? undefined : checkVal.code,
        Tins: isMultiTinVal()
          ? tinStr
          : parameters[1].Tin[0].Tin === 'All'
            ? undefined
            : tinStr.slice(1),
      };
      return callApi(payload, index);
    });

  try {
    const responses = await Promise.all(callsTree);
    if (
      !responses[0]?.Data?.SumOfcallVolume &&
      !responses[0]?.Data?.SumOftotalCallTimeInMinutes
    ) {
      CALLS_TREND_MOCK_DATA.status = 502;
      return CALLS_TREND_MOCK_DATA;
    } else {
      CALLS_TREND_MOCK_DATA.status = 200;
      let respObj = modifyResponseForTrend(responses, radio);
      respObj = fixResponseForTrends(respObj, radio);
      responses.forEach((response, k) => {
        if (checkedListCopy[k].checked) {
          response.Data.type = checkedListCopy[k].code;
          response.Data.SumOftotalCallTimeInMinutes = nFormatter(
            response.Data.SumOftotalCallTimeInMinutes / 60
          );
        }
      });
      const legends = responses.map((v) =>
        getTrendCardDetails(v) ? getTrendCardDetails(v) : []
      );
      return getDatamanipulation(
        responses,
        checkedListCopy,
        radio,
        legends,
        respObj
      );
    }
  } catch (error) {
    console.error(error);
    throw error;
  }
}
